import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OpPage } from 'components/customAntd/OpPage/OpPage';
import LocationsDrawer from './LocationsDrawer';
import LocationsTable from './LocationsTable';
import { AppDispatch, RootState } from 'store/store';
import { Location } from 'types/locationTypes';
import { fetchLocations } from 'store/slices/locationsSlice';
import { useTranslation } from 'react-i18next';


const Locations: React.FC = () => {
    const dispatch: AppDispatch = useDispatch();

    const orgId = useSelector((state: RootState) => state.globalOrg.globalOrgId);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState<Location | null>(null);
    const { t } = useTranslation();

    // Fetch locations
    useEffect(() => {
        dispatch(fetchLocations({ orgId, status: 1 }));
    }, [dispatch, orgId]);

    const handleEditClick = (location: Location) => {
        setSelectedLocation(location);
        setDrawerVisible(true);
    };

    const handleAddClick = () => {
        setSelectedLocation(null);
        setDrawerVisible(true);
    };

    const handleDrawerClose = () => {
        setDrawerVisible(false);
        setSelectedLocation(null);
    };

    return (
        <OpPage title={t('location.title')} tooltip={t('location.tooltip')}>
            <LocationsTable
                handleEditClick={handleEditClick}
                handleAddClick={handleAddClick}
            />
            <LocationsDrawer
                open={drawerVisible}
                onClose={handleDrawerClose}
                selectedLocation={selectedLocation}
            />
        </OpPage>
    );
}

export default Locations;
